export interface ILoginMetaData {
  userName: string;
}

export interface IForgetPasswordMeteData {
  userName: string;
  otp: string;
}

export interface IAuthStore {
  loginSide?: boolean;
  whiteLogo?: boolean;
  setLoginSide: (state: boolean) => void;
  setWhiteLogo: (state: boolean) => void;
  resetState: () => void;
  step: IAuthStepEnum;
  setStep: (state: IAuthStepEnum) => void;
  finalStep: IAuthStepEnum;
  setFinalStep: (state: IAuthStepEnum) => void;
  loginMetaData: ILoginMetaData;
  setLoginMetaData: (data: ILoginMetaData) => void;
}

export enum IAuthStepEnum {
  LOGIN = "login",
  // eslint-disable-next-line @typescript-eslint/no-mixed-enums
  CHECK_LOGIN_VERIFICATION_EMAIL = 0,
  CHECK_LOGIN_VERIFICATION_PHONE,
}
